import { Collection } from 'modules/core/lib/mobx-rest'

import QualificationEntry from 'modules/onboarding/store/models/QualificationEntry'

class QualificationEntries extends Collection<QualificationEntry> {
  get cacheKey(): string {
    return 'qualificationEntries'
  }

  model() {
    return QualificationEntry
  }
}

const singleton: QualificationEntries = new QualificationEntries()

export default singleton
